let viewportWidth = 750; // 画布宽度
const unitEnumSet = new Set(["width", "height", "top", "left", "right", "bottom", "size", "fixValue"]);

export const px2vw = (viewportWidth = 750, pixels: number) => {
  if (pixels === 1) return "1px";
  return `${((pixels / viewportWidth) * 100).toFixed(4)}vw`;
};

export const handleComponentPx2vw = (props) => {
  for (const key of Object.keys(props)) {
    if (unitEnumSet.has(key)) props[key] = px2vw(viewportWidth, props[key]);
  }
};

export const nodeDataPx2vw = (nodes: any[], viewportWidth = 750) => {
  (nodes || []).forEach((node) => {
    nodeDataPx2vw(node.children);
    for (const key of Object.keys(node)) {
      if (unitEnumSet.has(key)) node[key] = px2vw(viewportWidth, node[key]);
    }
  });
};

export const handlePageDataPx2vw = (pageData: Record<string, any>) => {
  const { elements } = pageData;
  if (!elements.length) return;
  viewportWidth = elements[0].nodes.width;
  elements.map((item) => {
    if (item?.nodes?.nodes?.length) {
      nodeDataPx2vw(item.nodes.nodes);
    }
  });
};
